// *** Create Group Component ****
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import thumb from "../../assets/img/post/add-pop-thumb.svg";
import profile_image_url from "../../assets/img/message/user-icon.svg";
import {Form,Alert} from 'react-bootstrap';
import { API } from "../../services/api";
import { getFavouriteChatUsers,saveChatGroup} from "../../services/apiMessage";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
const CreateGroup = (props) => {
const userData = JSON.parse(localStorage.getItem('userData'));
const [selectedFavorites, setSelectedFavorites] = useState([]);
const [groupName, setGroupName] = useState('');
const [groupmessage, setGroupMessage] = useState('');
const[isSucess,SetSucess]=useState(false);
const[ResponseMessage,SetResponseMessage]=useState("");
const [validationError, setValidationError] = useState('');
const[Favourites,setFavourites]=useState([]);
  useEffect(() => {
   fetchAllFavourites();
   
   
  }, [userData._id]);

  const fetchAllFavourites = async () => {
    let response = await getFavouriteChatUsers({userid:userData._id}); 
    if(response.status === true){
      setFavourites(response.favouriteUsers ||[]);
    }
  }
  const handleCheckboxChange = (friendId, isChecked) => {
    if (isChecked) {
      setSelectedFavorites([...selectedFavorites, friendId]);
    } else {
      setSelectedFavorites(selectedFavorites.filter(id => id !== friendId));
    }
    if (validationError) setValidationError('');
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (selectedFavorites.length === 0) {
      setValidationError('Please select at least one favourite');
      return; 
    }
     if (!groupName.trim()) {
    setValidationError('Please enter a group name');
    return;
     }
     if (!groupmessage.trim()) {
    setValidationError('Please enter a group message');
    return;
  }
    
    setValidationError('');

    let response = await saveChatGroup({userid:userData._id,groupname:groupName,users:selectedFavorites,message:groupmessage});
      if (response.status === true) {
        setGroupName("");
         SetSucess(true);
      SetResponseMessage("Group Created!");
      props.fetchAllInboxusers();
      closePopup();

    }
  
  };

 const closePopup = () => {
  setValidationError("");
    props.closePop();
 }

  return (
    <div>
      <Modal dialogClassName="custom-modal modal-dialog-centered" show={props.openPop} onHide={closePopup}>
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={thumb} className="mod-icon"></img>
            </div>
            <div className="header">
              <h4 className="modal-tittle">Create Group</h4>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
       
            <Form className="grp-user-list">
  {Favourites.length > 0 ? (
    <>
      <input 
        type="textbox" 
        className="form-control groupname"
        name="groupname" 
        id="groupname" 
        placeholder="Group name" 
        value={groupName}
        onChange={(e) => {
          setGroupName(e.target.value);
          setValidationError("");
        }}
      />
      <textarea class="form-control" placeholder="Message"  value={groupmessage}
        onChange={(e) => {
          setGroupMessage(e.target.value);
          setValidationError("");
        }}></textarea>
      
      {Favourites.map((fav, index) => (
        <div className="mb-3 d-flex align-items-center user-itm" key={index}>
          {fav.friendId.profileSettings ? 
            (fav.friendId.profileSettings.isPrivateProfile === false && 
             fav.friendId.profileSettings.showprofileImage === true) ?
              <img 
                src={fav.friendId?.profileImage?.url 
                  ? API.uploadFilePath + fav.friendId?.profileImage?.url
                  : profile_image_url
                } 
                alt="test" 
                className="user-thumb" 
              /> :
              <img src={profile_image_url} alt="test" className="user-thumb" /> :
            <img src={profile_image_url} alt="test" className="user-thumb" />
          }

          <Form.Check 
            type="checkbox" 
            id={`checkbox-${fav.friendId._id}`} 
            label={fav.friendId.firstName}
            onChange={(e) => handleCheckboxChange(fav.friendId._id, e.target.checked)}
          />
        </div>
      ))}
    </>
  ) : (
    <div>No favorites to display</div>
  )}

  {validationError && (
    <Alert variant="danger" className="mb-3">
      {validationError}
    </Alert>
  )}
</Form>

             
        </Modal.Body>
        <Modal.Footer className="modal-center modal-footer" >
         
          <button
            type="button"
            className="pop-primary btn btn-secondary"
            onClick={(e) => {
              handleSubmit(e);
            }}
            disabled={Favourites.length === 0}
          >
           Create Group
          </button>

        
        </Modal.Footer>
      </Modal>
        {isSucess && (<ResponsePopup 
                      isSucess={isSucess} 
                      CancelPopup={() => { 
                       SetSucess(false);
                      }} 
                      message={ResponseMessage}
                    />)}
    </div>
  );
};
export default CreateGroup;